/* eslint-disable prettier/prettier */
//import Alpine from 'alpinejs'
//Alpine.start()

//IMPORT FILES
import { initMenu } from './menu';
import { initFiltering } from './filtering';
//import { initMap } from './map';

const referenceExists = document.querySelectorAll('.reference-page');
//const mapExists = document.getElementById('map');
//INIT FUNCTIONS
initMenu();
if (referenceExists.length > 0) {
  initFiltering();
}
if (document.getElementsByClassName('hero-section').length != 0) {
	import('./hero').then(function (page) {
		page.initHeroScroll();
	});
}
if (document.getElementsByClassName('status-load-button').length != 0) {
	import('./status').then(function (page) {
		page.initLoadMoreStatus();
	});
}
if (document.getElementsByClassName("splide__imagecarousel").length > 0) {
	import('./imageSplide').then(function (page) {
		page.initSplideImageCarousel(document.getElementsByClassName("splide__imagecarousel") as HTMLCollectionOf<HTMLElement>);
	});
}
//if (document.getElementsByClassName('map-section__office-map').length != 0) {
//	import('./map').then(function (page) {
//		page.initMap();
//	});
// }
